module.exports = __webpack_public_path__ + "static/media/ibm-logo.91a9589b.png";